<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Checkout</h4>
  <button type="button" class="close" aria-label="Close" (click)="CloseCheckoutModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-container *ngIf="cartService.CartDetails | async as cart; else loadingCart">
    <h4>Total Due: ${{cart.Total}}</h4>

    <ng-container *ngIf="CustomerPaymentInfo$ | async as CustomerPaymentInfo; else loadingCPI">
      <ng-container *ngIf="FormAction=='select'">
        <form [formGroup]="checkoutForm" (submit)="DoCheckout()">
          <p>Select a stored payment method to use, or <a [routerLink]="[]" (click)="SwitchFormAction()">add a new payment
              method</a>.</p>
          <p><em>Please note: For your security, we do not store your full credit card information (only the last 4
              digits). Rather, your payment processor provides us with a secure, unique token that cannot be used by
              anyone else to charge your account.</em></p>
          <div class="form-group">
            <label for="CPI">Payment Method</label>
            <select formControlName="cpi" id="CPI" class="custom-select">
              <option disabled [ngValue]="null" value="">--Please Select--</option>
              <option *ngFor="let cpi of CustomerPaymentInfo$ | async" value="{{cpi.cpi_key}}">
                <ng-container [ngSwitch]="cpi.apm_type">
                  <ng-container *ngSwitchCase="'credit card'">{{cpi.apm_method}} {{ cpi.cpi_cc_number_display }} (exp
                    {{ cpi.cpi_cc_expire | date: 'MM/yyyy' }})</ng-container>
                  <ng-container *ngSwitchCase="'ACH'"> {{ cpi.cpi_eft_account_type === 'C' ? 'Checking' : 'Savings' }}:
                    {{ cpi.cpi_eft_account_number_display }}</ng-container>
                </ng-container>
              </option>
            </select>
          </div>
          <div class="form-group d-flex flex-row-reverse">
            <button class="btn btn-success" *ngIf="!CheckoutProcessing"
              [disabled]="(checkoutForm.statusChanges | async)!='VALID'">Pay Now</button>
            <span *ngIf="CheckoutProcessing">
              <app-load-indicator description="process your payment"></app-load-indicator>
            </span>
          </div>
          <ngb-alert *ngIf="CheckoutError" type="danger" [dismissible]="false">
            <app-dynamic-content [blocktitle]="'Checkout Exception'" [inline]="true"></app-dynamic-content>
          </ngb-alert>
        </form>
      </ng-container>

      <ng-container *ngIf="FormAction=='add'">
        <p>Add a new payment method below<ng-container *ngIf="CustomerPaymentInfo.length > 0">, or <a [routerLink]="[]"
              (click)="SwitchFormAction()">select a saved payment method</a></ng-container>.</p>
              <p><em>Please note: For your security, we do not store your full credit card information (only the last 4
                digits). Rather, your payment processor provides us with a secure, unique token that cannot be used by
                anyone else to charge your account.</em></p>
        <ngb-alert *ngIf="PaymentInfoError" type="danger" [dismissible]="false" class="mb-2">{{PaymentInfoError}}
        </ngb-alert>
        <pac-payment-details *ngIf="PaymentMethods$ | async as PaymentMethods; else loading" class="pt-2"
          [Defaults]="{ cpi_preferred_flag: true }" [Action]="Action" [ShowClose]="true"
          [CustomerPaymentInfo]="CustomerPaymentInfo" [PaymentMethods]="PaymentMethods"
          (BeforeSave)="OnBeforeSave($event)" (AfterSave)="OnAfterSave($event)" (Error)="OnError($event)"
          (Close)="Close()" (Busy$)="Busy$.next($event)">
        </pac-payment-details>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #loadingCart>
    <p>
      <app-load-indicator description="load your cart details"></app-load-indicator>
    </p>
  </ng-template>
  <ng-template #loadingCPI>
    <p>
      <app-load-indicator description="load your payment details"></app-load-indicator>
    </p>
  </ng-template>
  <ng-template #loading>
    <p>
      <app-load-indicator description="load available payment options"></app-load-indicator>
    </p>
  </ng-template>
</div>